import React from "react";
import PropTypes from "prop-types";
import imagesLoaded from "imagesloaded";

/**
 * Display an image, will add a .is-loading while loading and
 * is-loaded once loaded.
 */
export default class ImageElement extends React.Component {
  static displayName = "ImageElement";
  static propTypes = {
    className: PropTypes.string,
    alt: PropTypes.string.isRequired,
    src: PropTypes.string,
  };

  static defaultProps = {
    className: "",
  };

  /**
   * @constructor
   * @param  {Object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      wasLoaded: false,
    };
    this.image = null;
    this.loadImage = this.loadImage.bind(this);
  }

  /**
   * Load the src image
   */
  loadImage(force = false) {
    if (this.image && (force || !this.state.wasLoaded)) {
      this.setState({ loaded: false });
      const imgLoaded = imagesLoaded(this.image);
      imgLoaded.on("done", img => {
        // Image just finished loading, give some ms break the browser
        // will take the hand to pre-render the image.
        setTimeout(() => {
          this.setState({ loaded: true });
        }, 10);
      });

      imgLoaded.on("fail", img => {
        console.error("IMAGE", img, "fail to load");
      });

      imgLoaded.on("always", () => {
        this.setState({ wasLoaded: true });
      });
    } else {
      console.log("dont need to load image. ", {
        image: this.image,
        force: force,
        wasLoaded: this.state.wasLoaded,
      });
    }
  }
  /**
   * @override
   * @param  {Object} prevProps
   * @param  {Object} nextState
   */
  componentDidUpdate(prevProps, nextState) {
    if (prevProps.src !== this.props.src) {
      this.loadImage(true);
    }
  }

  /**
   * @override
   */
  componentDidMount() {
    this.loadImage();
  }

  /**
   * @override
   */
  render() {
    let { className, ...otherProps } = this.props;
    className += " " + (this.state.loaded ? " is-loaded" : " is-loading");
    return (
      <img
        className={className}
        alt={this.props.alt}
        ref={image => (this.image = image)}
        {...otherProps}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Image.js